import { ProductCheckpointQuestionListDTO } from '../product-checkpoint-question/product-checkpoint-question-list.dto';
import { ProductListDTO } from '../product/product-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductCheckpointDTO extends TeamAccessDTO {

    title: string;

    description: string;

    product: ProductListDTO;

    questions: Array<ProductCheckpointQuestionListDTO>;

}
